<template>
  <div class="Dialog tips prize-pool">
    <div class="inner">
      <i class="close" @click="onClose"></i>
      <div class="title">{{lotteryInfo.num}}{{currencyName}}奖池</div>
      <p class="description">100%赢好礼～</p>
      <div class="pool-con" v-if="lotteryInfo.award && lotteryInfo.award.length>0">
        <div class="pool-con-item" v-for="award in lotteryInfo.award" :key="award.award_id" >
          <img :src="award.url" alt="">
          <p>{{award.name}}</p>
        </div>
      </div>
      <div class="pool-con" v-else>
        <div class="pool-con-item">
          <img :src="currentAward.url" alt="">
          <p>{{currentAward.name}}</p>
        </div>
      </div>
      <div class="tips-btn">
        <div class="tips-btn-t" @click="onClose">确定</div>
      </div>
      <p class="prize-pool-tips">奖品发货后，请返回游戏邮箱中领取</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Award",
  props: ["isShown", "lotteryInfo", "currentAward", "onClose", "currencyName"]
}
</script>

<style scoped>
</style>
